import React from 'react'
import PropTypes from 'prop-types'
import PlanStatusIcon from '../badges/PlanStatusIcon'

// The `__header-wrapper` is always rendered so the gray card chrome (border,
// neutral background, padding) stays consistent regardless of whether the
// admin has chosen to hide the title row. `showHeader` only gates the inner
// `__header` row (label + optional status icon) — turn it off to render a
// "headless" card that just wraps the categories.
function PlanCard ({ plan, cardLabel, showHeader, showStatus, statusStyleOverrides, children }) {
  return (
    <div className='__header-wrapper flex flex-col'>
      {showHeader ? (
        <div className='__header flex items-center font-bold'>
          {showStatus ? (
            <div className='__status'>
              <PlanStatusIcon status={plan.status} size={23} statusStyleOverrides={statusStyleOverrides} />
            </div>
          ) : null}
          <span>{cardLabel}</span>
        </div>
      ) : null}
      {children}
    </div>
  )
}

PlanCard.propTypes = {
  plan: PropTypes.shape({
    name: PropTypes.string,
    status: PropTypes.string
  }).isRequired,
  cardLabel: PropTypes.string,
  showHeader: PropTypes.bool,
  showStatus: PropTypes.bool,
  statusStyleOverrides: PropTypes.object,
  children: PropTypes.node
}

PlanCard.defaultProps = {
  cardLabel: 'The Plan',
  showHeader: true,
  showStatus: true
}

export default PlanCard
